import axios from '../../../config-axios'
import { ElMessage } from 'element-plus'

export default {
    namespaced: true,
    state: () => ({
        modemList: [],
        deviceListByModem: [],
        frameWareList: [],
    }),
    getters: {
        getModemList(state) {
            return state.modemList
        },
        getDeviceListByModem(state) {
            return state.deviceListByModem
        },
        getFrameWareList(state) {
            return state.frameWareList
        }
    },
    mutations: {
        setModemList(state, opinions) {
            state.modemList = opinions
        },
        setDeviceListByModem(state, options) {
            state.deviceListByModem = options
        },
        setPhoneNumberOfModem(state, opinions) {
            let indexModem = state.modemList.findIndex(el=>{return el.id == opinions.id})
            if (indexModem != -1) {
                state.modemList[indexModem].sim_phone_number = opinions.phone_number.slice(0,20)
            }
        },
        setFrameWareList(state, opinions) {
            state.frameWareList = opinions
        }
    },
    actions: {
        async getModemList(context) {
            await axios.get('sensor/modem/').then(response=>{
                context.commit('setModemList', response.data)
            })
          },
          async getDevicesByModem(context, options) {
            await axios.get('sensor/modem/'+options+'/').then(response=>{
                context.commit('setDeviceListByModem', response.data)
            })
          },
          async putPhoneNumberOfModem(context, options) {
            await axios.put('sensor/modem/', options).then(response=>{
                if (response.data.status) {
                    context.commit('setPhoneNumberOfModem', options)
                    ElMessage.success('Номер сохранён')
                } else {
                    ElMessage.error('Ошибка, не удалось сохранить номер')
                }
            })
          },
          async getApiFrameWareList(context, options) {
            await axios.get('upload_frameware/?type='+options).then(response=>{
                context.commit('setFrameWareList', response.data.frame_ware)
            })
          },
          async postUpdatingQueue(context, options) {
            await axios.post('update_modem/', options).then(response=>{
                if (response.data.status) {
                    ElMessage.success('Обновление стало в очередь')
                } else {
                    ElMessage.error(response.data.text)
                }
            })
          }
    }
}